/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import classNames from "classnames/dedupe";
import React, { FC } from "react";

export interface IPaginationItemProps {
  page?: number;
  active?: boolean;
  onClick?(page: number): void;
}

const PaginationItem: FC<IPaginationItemProps> = ({
  page,
  active,
  onClick,
}) => {
  return (
    <li
      className={classNames({ active, dots: typeof page !== "number" })}
      onClick={() => onClick && onClick(page)}
      data-testid="pagination-item"
    >
      <span>{page || "..."}</span>
    </li>
  );
};

export default PaginationItem;
